<template>
    <div>
        <div class="row">
            <div class="col-12" >
                <div class="toast mw-100" role="alert" data-autohide="false" aria-live="assertive" aria-atomic="true">
                    <div class="toast-header">
                        <strong class="mr-auto">
                            <span >{{ history[0].author}}</span>
                        </strong>
                        <small>{{ history[0].time }}</small>
                    </div>
                    <div class="toast-body">
                        <ul>
                            <li v-html="change.description" v-for="change in history" class="text-break" style="white-space: pre-wrap"></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "toast-history",
    props: {
        history: {
            type: Array,
            required: true
        },
        admin: {
            type: Number,
            required: true
        }
    }
}
</script>

